export const dataTable = {
    namespaced: true,
    state: {
        total: 0,
        idle_rules: []
    },
    getters: {
        getTotal: state => state.total,
        getIdleRules: state => state.idle_rules
    },
    mutations: {
        SET_TOTAL(state, payload) {
            state.total = payload
        },
        SET_IDLE_RULES(state, payload) {
            state.idle_rules = [...payload]
        }
    },
    actions: {
        setTotal({ commit }, payload) {
            commit('SET_TOTAL', payload)
        },
        setIdleRules({ commit }, payload) {
            commit('SET_IDLE_RULES', payload)
        }
    }
}